module.exports = {"321202001":"城东街道","321202002":"城西街道","321202003":"城南街道","321202004":"城中街道","321202005":"城北街道","321202007":"京泰路街道","321202050":"红旗街道","321202100":"九龙镇","321202101":"罡杨镇","321202102":"苏陈镇","321202103":"华港镇","321202406":"海陵工业园区","321202407":"农业示范园区","321202408":"火车站街区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/321202.json
// module id = 1028
// module chunks = 0